export const LIVESCORE = 'livescore';
export const STANDINGS = 'standings';
export const PROGRAMME = 'team-programme';
export const TOURNAMENT_PROGRAMME = 'tournament-programme';
export const BASKETBALL_LIVESCORE = 'basketball-livescore';
export const BASKETBALL_STANDINGS = 'basketball-standings';
export const FOOTBALL_SINGLE_EVENT = 'football-single-event';
export const BASKETBALL_SINGLE_EVENT = 'basketball-single-event';
export const BASKETBALL_TOURNAMENT_PROGRAMME = 'basketball-tournament-programme';
export const BASKETBALL_TEAM_PROGRAMME = 'basketball-team-programme';
export const KNOCK_OUT = 'knockout';
export const PLAYER = 'player';
export const TEAM = 'team';
export const TENNIS_SINGLE_EVENT = 'tennis-single-event';
export const TENNIS_LIVESCORE = 'tennis-livescore';
export const TEAM_SQUAD = 'team-squad';
export const SINGLE_EVENT = 'single-event';
export const TENNIS_PLAYOFF = 'tennis-playoff';
export const PLAYOFF = 'playoff';
export const TENNIS_RANKING = 'tennis-ranking';
export const RANKING = 'ranking';
export const TOP_SCORERS = 'top-scorers';
export const MOST_DECORATED = 'most-decorated';
export const PLAYER_H2H = 'player-h2h';
export const TENNIS_ATHLETE_PROGRAMME = 'tennis-athlete-programme';
export const ATHLETE_PROGRAMME = 'athlete-programme';
export const TENNIS_TOURNAMENT_PROGRAMME = 'tennis-tournament-programme';
export const TEAM_H2H = 'team-h2h';
export const TEAM_H2H_MATCH = 'team-h2h-match';
export const MATCHES_H2H = 'matches-h2h';
export const ODDS = 'odds';
export const ROUND = 'round';
export const LINEUPS = 'lineups';

export const MULTISPORT_EVENTS = 'multisport-events';

export const STAKES = 'stakes';

// Ice Hockey
export const ICE_HOCKEY_LIVESCORE = 'ice-hockey-livescore';
export const ICE_HOCKEY_STANDINGS = 'ice-hockey-standings';
export const ICE_HOCKEY_SINGLE_EVENT = 'ice-hockey-single-event';

export const MATCH_CENTER = 'match-center';

export const TIMELINE = 'timeline';
